import { DynamicReviewsExtension, CheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

export const LAYOUT_OPTIONS = [
  {
    value: DynamicReviewsExtension.LayoutStyle.RATING_BADGE,
    label: 'Rating Badge',
    description: 'Display stars and review count under each product',
    recommended: true,
  },
  {
    value: DynamicReviewsExtension.LayoutStyle.REVIEW_CAROUSEL,
    label: 'Review Carousel',
    description: 'Standalone carousel showcasing all reviews',
    recommended: false,
  },
  {
    value: DynamicReviewsExtension.LayoutStyle.REVIEW_LIST,
    label: 'Review List',
    description: 'All reviews in one section',
    recommended: false,
  },
];

export const RATING_BADGE_TYPE_OPTIONS = [
  { value: DynamicReviewsExtension.RatingBadgeType.STARS, label: 'Stars' },
  { value: DynamicReviewsExtension.RatingBadgeType.NUMBER, label: 'Number Of Reviews' },
  { value: DynamicReviewsExtension.RatingBadgeType.BOTH, label: 'Both' },
];

export const CAROUSEL_NAVIGATION_OPTIONS = [
  {
    value: DynamicReviewsExtension.CarouselNavigationStyle.ARROWS,
    label: 'Arrows',
    description: 'Navigate between products using arrow buttons',
  },
  {
    value: DynamicReviewsExtension.CarouselNavigationStyle.SCROLLBAR,
    label: 'Scroll Bar',
    description: 'Scroll horizontally through the product list with a draggable bar',
  },
];

export const STAR_POSITION_OPTIONS = [
  { value: DynamicReviewsExtension.StarPosition.TOP, label: 'At The Top' },
  { value: DynamicReviewsExtension.StarPosition.BOTTOM, label: 'At The Bottom' },
  { value: DynamicReviewsExtension.StarPosition.NONE, label: "Don't Show" },
];

export const BORDER_OPTIONS = [
  { value: CheckoutExtensionUI.BorderType.BASE, label: 'Base' },
  { value: CheckoutExtensionUI.BorderType.DOTTED, label: 'Dotted' },
  { value: CheckoutExtensionUI.BorderType.NONE, label: 'None' },
];

export const BORDER_WIDTH_OPTIONS = [
  { value: CheckoutExtensionUI.BorderWidth.BASE, label: 'Base' },
  { value: CheckoutExtensionUI.BorderWidth.MEDIUM, label: 'Medium' },
];

export const CORNER_RADIUS_OPTIONS = [
  { value: CheckoutExtensionUI.CornerRadius.NONE, label: 'None' },
  { value: CheckoutExtensionUI.CornerRadius.SMALL, label: 'Small' },
  { value: CheckoutExtensionUI.CornerRadius.BASE, label: 'Base' },
  { value: CheckoutExtensionUI.CornerRadius.LARGE, label: 'Large' },
];

export const PADDING_OPTIONS = [
  { value: CheckoutExtensionUI.Padding.NONE, label: 'None' },
  { value: CheckoutExtensionUI.Padding.SMALL300, label: 'Small' },
  { value: CheckoutExtensionUI.Padding.BASE, label: 'Base' },
  { value: CheckoutExtensionUI.Padding.LARGE200, label: 'Large' },
];

export const BACKGROUND_COLOR_OPTIONS = [
  { value: 'transparent', label: 'None' },
  { value: 'base', label: 'Base' },
  { value: 'subdued', label: 'Subdued' },
];

export const DYNAMIC_FIELDS_MENTION_CONFIG = {
  items: [
    {
      name: '{rating_number}',
      description: 'Rating Number',
      searchTerm: 'rating_number',
      replaceableName: '{rating_number}',
    },
    {
      name: '{review_text}',
      description: 'Review Text',
      searchTerm: 'review_text',
      replaceableName: '{review_text}',
    },
    {
      name: '{reviewer_name}',
      description: 'Reviewer Name',
      searchTerm: 'reviewer_name',
      replaceableName: '{reviewer_name}',
    },
    {
      name: '{product_name}',
      description: 'Product Name',
      searchTerm: 'product_name',
      replaceableName: '{product_name}',
    },
  ],
  triggerChar: '{',
  labelKey: 'description',
  descriptionKey: 'name',
  filterByKey: 'searchTerm',
  removeTriggerCharOnSelect: true,
};
